"use strict";

import gsap from "gsap";
import CustomEase from "gsap/CustomEase";

const onloadAnimaiton = function (container) {
	const bgdText = container.querySelector(".bgd-text");
	const image = container.querySelector(".hero__image");
	const introEls = container.querySelectorAll(".hero__text .intro span");
	const aboutEls = container.querySelectorAll(".hero__text .about--short > *");

	gsap.registerPlugin(CustomEase);

	const mediaSizes = gsap.matchMedia();
	const tl = gsap.timeline({
		defaults: {
			duration: 1,
			ease: CustomEase.create("custom", "M0,0 C0.069,1 0.458,1 1,1 "),
		},
	});

	mediaSizes.add("(max-width: 1024px)", () => {
		tl.to(aboutEls, { y: 0, stagger: -0.2, duration: 1.5 }, "<")
			.to(aboutEls, { opacity: 1, stagger: -0.1, duration: 0.4, ease: "none" }, "<0.2")
			.to(introEls, { y: 0, stagger: -0.2, duration: 1.5 }, "<")
			.to(introEls, { opacity: 1, stagger: -0.1, duration: 0.4, ease: "none" }, "<0.2")
			.to(image, { scale: 1 }, "<-=0.2")
			.to(image, { opacity: 1, duration: 0.4, ease: "none" }, "<0.4")

			.to(bgdText, { opacity: 1, duration: 3, ease: "none" }, 0);
	});

	mediaSizes.add("(min-width: 1025px)", () => {
		tl.to(image, { scale: 1 })
			.to(image, { opacity: 1, duration: 0.4, ease: "none" }, "<0.4")
			.to(introEls, { x: 0, stagger: 0.2, duration: 1.5 }, "<")
			.to(introEls, { opacity: 1, stagger: 0.1, duration: 0.4, ease: "none" }, "<0.2")
			.to(aboutEls, { y: 0, stagger: 0.2, duration: 1.5 }, "<")
			.to(aboutEls, { opacity: 1, stagger: 0.1, duration: 0.4, ease: "none" }, "<0.2")
			.to(bgdText, { opacity: 1, duration: 3, ease: "none" }, 0);
	});

	return tl;
};

export default onloadAnimaiton;
